import { render, staticRenderFns } from "./AtomFormSelectionWrapper.vue?vue&type=template&id=733e0f98&scoped=true&"
import script from "./AtomFormSelectionWrapper.vue?vue&type=script&lang=js&"
export * from "./AtomFormSelectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AtomFormSelectionWrapper.vue?vue&type=style&index=0&id=733e0f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e0f98",
  null
  
)

export default component.exports